import $ from "jquery";
import ReactDOM from "react-dom";
import { Fragment, useCallback, useContext, useEffect, useState } from "react";
import { PriceStockPopup } from "./priceStockPopup";
import { axiosInstance } from "../../axios/axiosInstance";
import { Toast } from "bootstrap";
import { GlobalContext } from "../../Context/GlobalContext";
import { debounce_new } from "../../assets/constValue";
import { WishlistItem } from "./addWhistList";
import { isNumber } from "lodash";
import { useGlobalFunction } from "../../Context/GlobalFunctionContext";
import { useAuth } from "../../Context/AuthContext";
import { QuantityStripper } from "./quantityStripper";
import { ConvertToFloat } from "./common";
import { ImageWithDefault } from "./imageWithDefault";
import { ProductLink } from "./productLink";

export const ProductCard = ({ data, index }) => {
  const globalcontext = useContext(GlobalContext);
  const { handleAddtoCart } = useGlobalFunction();
  const [PriceTabelData, setPriceTabelData] = useState(null);
  const [productStock, setProductStock] = useState(null);
  const [productPrice, setProductPrice] = useState(null);
  const [ProductData, setProductData] = useState(data);
  const [isAdded, setIsadded] = useState(data.isAdded);
  const [qty, setQty] = useState({});
  const { userId, eBayBlock, isAuthenticated } = useAuth();
  const isGuest = isAuthenticated === false;
  const { getProductPrice, getStockStatus } = useGlobalFunction();

  useEffect(() => {
    setProductData(data);
    if (data && data.productId) {
      setQty({ prod_id: data.productId, qty: 0 });
      fetchStockStatus(data.productId);
      fetchProductPrice(data.productId);
    }
  }, [data]);

  const fetchStockStatus = async (productId) => {
    let response = await getStockStatus(productId);
    if (response) setProductStock(response);
  };
  const fetchProductPrice = async (productId) => {
    let price = await getProductPrice(productId ?? 0);
    if (price) setProductPrice(ConvertToFloat(price));
  };

  useEffect(() => {
    if (globalcontext.CartItem && globalcontext.CartItem.cartItem && globalcontext.CartItem.cartItem.length > 0) {
      var products = globalcontext.CartItem.cartItem;
      var filterProductId = products.find((item) => String(item.prod_id) == String(ProductData.productId));
      setIsadded(!!filterProductId);
      if (filterProductId)
        setQty({
          prod_id: ProductData.productId,
          qty: filterProductId.qty ?? 1,
        });
    } else {
      setIsadded(false);
      setQty({ prod_id: ProductData.productId, qty: 0 });
    }
  }, [globalcontext.CartItem]);

  const handleAddtocartClick = (event) => {
    // AddtoCart(1, "ADD");
    handleAddtoCart(ProductData.productId, 1, "ADD");
    setIsadded(true);
    const button = $(event.currentTarget);
    window.addCartEffect(button);
  };
  const handleMouseEnter = useEffect(() => {
    var d = {
      type: "PriceTable",
      userid: String(userId),
      prodid: data.productId,
      productCode: data.productCode,
    };
    axiosInstance
      .post("GetPriceTable/MouseHover", d)
      .then((response) => {
        if (response.data != "") {
          setPriceTabelData(response.data);
        }
      })
      .catch((error) => console.log(error.message));
  }, []);

  return (
    <Fragment>
      {/* {PriceTabelData &&
        productStock &&
        ReactDOM.createPortal(
          <PriceTablePopup
            prodData={ProductData}
            data={PriceTabelData}
            stockStatus={productStock}
          />,
          document.body
        )} */}
      <div className="product-list" data-id={ProductData.productId} key={ProductData.productId}>
        <div className="product-items">
          <ProductLink to={ProductData.link}>
            <ImageWithDefault src={data.prodImage} alt="product-name" />
          </ProductLink>
          <div className="wishlist-products">
            {!isGuest && <WishlistItem productId={ProductData.productId} />}

            {ProductData.isClearance ? (
              <small className="product-stage new-clearance">CLEARANCE</small>
            ) : (
              ProductData.isNew && <small className="product-stage new-product">New</small>
            )}
          </div>
        </div>
        <div className="product-details">
          <h6 className="product-title">
            <ProductLink to={ProductData.link}>{ProductData.description}</ProductLink>
          </h6>
          {data.isUnavailable ? (
            <div className="product-unavailable">
              <p>Temporarily Unavailable</p>
            </div>
          ) : isAdded ? (
            <div className="product-price">
              <p>${productPrice ? ConvertToFloat(productPrice) : 0}</p>
              <span className="pro-added">
                <i className="fa-solid fa-check" /> Added
              </span>
            </div>
          ) : data.showBulkBuy ? (
            <div className="product-price">
              <p>${ConvertToFloat(ProductData.price)}</p>
              <PriceStockPopup product={ProductData} />
            </div>
          ) : (
            <div className="product-price">
              <p>${ConvertToFloat(ProductData.price)}</p>
            </div>
          )}
          <div className="product-code">Code: {ProductData.productCode}</div>
          {data.isBuyOption ? (
            <div className="product-button button-effect">
              <button type="submit" className="btn btn-products btn-buying">
                <span className="wes-buying-option" /> <span className="btn-options">Buying Options</span>
              </button>
            </div>
          ) : data.isUnavailable ? (
            <div className="product-button">
              <button type="submit" className="btn btn-products btn-unavailable">
                Unavailable
              </button>
            </div>
          ) : eBayBlock && ProductData.eBayBlock ? (
            <div className="product-button">
              <button type="submit" className="btn btn-products btn-unavailable">
                Unavailable
              </button>
            </div>
          ) : (
            <QuantityStripper
              prd={qty}
              params={{
                code: ProductData.productCode,
                desc: ProductData.description,
                img: ProductData.prodImage,
              }}
            />
          )}
        </div>
      </div>
    </Fragment>
  );
};
